import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    font_family: 'Montserrat',
    primary_color: '#0A1A50',
    secondary_color: '#B5BBC4',
    text_color: '#2d2d2d',
    background_color: '#ffffff'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTheme();
  }, []);

  const fetchTheme = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/cms/settings`);
      const settings = response.data;
      
      setTheme({
        font_family: settings.font_family || 'Montserrat',
        primary_color: settings.primary_color || '#0A1A50',
        secondary_color: settings.secondary_color || '#B5BBC4',
        text_color: settings.text_color || '#2d2d2d',
        background_color: settings.background_color || '#ffffff'
      });
      
      // Apply font to body
      if (settings.font_family) {
        document.body.style.fontFamily = `'${settings.font_family}', sans-serif`;
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error fetching theme:', error);
      setLoading(false);
    }
  };

  const value = {
    theme,
    refreshTheme: fetchTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
